import { connect } from 'react-redux';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import { getSecondaryMarketRealtimeAstroProductFromTab } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  price: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  tradeWay: TradeWay;
}>;

export type TradingSidePanelProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const quoteId = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormQuoteId(state, tabId)!;
  const price = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuoteSettlementPrice(state, quoteId)!;
  const priceType = fromSecondaryMarket.realtimeQuote.quote.getSecondaryQuotePriceType(state, quoteId)!;
  const product = getSecondaryMarketRealtimeAstroProductFromTab(state, tabId);
  const priceCurrency = product?.data?.currency!;
  const tradeWay = fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormTradeWay(state, tabId)!;

  return {
    price,
    priceType,
    priceCurrency,
    tradeWay,
  };
};

export const connectTradingSidePanel = connect(mapStateToProps);
